<div #widgetContainer class="ftf-widget-container"></div>